///Import react section
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import AddtIcon from '@material-ui/icons/AddTwoTone'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import LinkMaterial from '@material-ui/core/Link'
import DocumentsIcon from '@material-ui/icons/DoneAll'
import Fab from '@material-ui/core/Fab'
import Tooltip from '@material-ui/core/Tooltip'
import { Translate, getTranslate } from 'react-localize-redux'
import DownloadIcon from '@material-ui/icons/CloudDownload'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import DataTable from '../common/DataTable'
import LoadingPage from '../common/LoadingPage'
import Toaster from '../common/Toaster'
import SearchInput from '../common/SearchInput/SearchInput'
import OptionsMenu from '../common/OptionsMenu'

/** Action and helpers */
import {
	loadContractsFromBackEnd,
	getContractsCount,
	createContractData,
	CHANGE_CONTRACTS_SORT_CRITERIA,
	CHANGE_CONTRACTS_SORT_QUERY,
	CHANGE_CONTRACTS_PAGINATION,
	downloadReportSupplierContractors,
} from '../../store/supplierconstracts/SupplierConstractAction'
import { converListToArray } from '../../store/helpers/ListHelper'
import { canBeModuleDocumentsEnvSupplier } from '../../store/helpers/RolesHelper'
import { showErrorToaster, showSuccessToaster } from '../../store/helpers/ToasterHelpers'
import { DOCUMENT_ENVIROMENTAL } from '../../store/helpers/ResourcesHelper'
import { getColorStatusContract, getDescriptionStatusContract } from '../../store/helpers/DocumentsHelper'

/**
 * Index view
 */
class IndexDocuments extends Component {
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			showToaster: false,
			toasterMessage: null,
			toasterVariant: '',
			openModalContract: false,
			contract: {
				attachments: [],
				name: '',
			},
			showMenu: true,
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		if (!this.props.isLoadingUser) {
			this.props.loadContracts(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage,
				DOCUMENT_ENVIROMENTAL
			)
			this.props.getContractsCount(DOCUMENT_ENVIROMENTAL)
		}
	}

	/**
	 * componentDidUpdate
	 *
	 * @param {*} prevProps
	 * @param {*} prevState
	 * @memberof Index
	 */
	componentDidUpdate(prevProps, prevState) {
		let prevCompanyToken = prevProps.selectedCompany ? prevProps.selectedCompany.token : ''
		if (this.props.selectedCompany && prevCompanyToken !== this.props.selectedCompany.token) {
			this.props.loadContracts()
			this.props.getContractsCount(DOCUMENT_ENVIROMENTAL)
		} else if (
			prevProps.sortCriteria.by !== this.props.sortCriteria.by ||
			prevProps.sortCriteria.ascending !== this.props.sortCriteria.ascending ||
			prevProps.searchQuery !== this.props.searchQuery ||
			prevProps.page !== this.props.page ||
			prevProps.rowsPerPage !== this.props.rowsPerPage
		) {
			this.props.loadContracts(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage,
				DOCUMENT_ENVIROMENTAL
			)
		}
	}

	/**
	 * On change sort criteria
	 *
	 * @param {*} sortBy
	 * @param {*} sortAscending
	 * @memberof Index
	 */
	onChangeSortCriteria(sortBy, sortAscending) {
		this.props.changeSortCriteria(sortBy, sortAscending)
	}

	/**
	 * On change search value
	 *
	 * @param {*} searchQuery
	 * @memberof Index
	 */
	onChangeSearchValue(searchQuery) {
		this.props.changeSearchQuery(searchQuery)
	}

	/**
	 * Get contracts portal counter
	 *
	 * @returns
	 * @memberof Index
	 */
	getCounterMessage() {
		const { classes } = this.props
		if (this.props.contracts) {
			let totalContracts = this.props.contracts.length
			return (
				<div>
					{this.props.translate('common.showing')}&nbsp;
					<span className={classes.showingCounter}>{totalContracts}</span>&nbsp;
					{this.props.translate('common.of')}&nbsp;
					<span>{this.props.contractsCount}</span>&nbsp;
					{this.props.translate('common.records')}
				</div>
			)
		}
	}

	/**
	 * On render cell item custom
	 * @param {*} dataSource
	 * @param {*} item
	 */
	onRenderCellItem(dataSource, item) {
		if (dataSource === 'status') {
			return (
				<Tooltip title={getDescriptionStatusContract(item.status)}>
					<Avatar data-cy='avatar' style={{ backgroundColor: getColorStatusContract(item.status) }}>
						<DocumentsIcon />
					</Avatar>
				</Tooltip>
			)
		}
		if (dataSource === 'name') {
			return (
				<LinkMaterial
					key={item.token}
					component={'a'}
					target='_blank'
					color='primary'
					href={`${process.env.REACT_APP_SIP_URL_ADMINISTRATION}/Documents/SupplierContract/${item.token}/${item.file_name}.pdf`}
				>
					<DownloadIcon style={{ marginTop: '-7px' }} /> {item.name}
				</LinkMaterial>
			)
		}
	}

	/**
	 * onRowClick
	 * @param {*} calendar
	 * @param {*} event
	 */
	onRowClick(document, event) {
		let tagName = event.target.tagName
		if (tagName !== 'svg' && tagName !== 'A') {
			this.props.history.push(`/documents/${document.token}`)
		}
	}

	/**
	 * Get the card content
	 *
	 * @memberof Index
	 */
	getCardContent() {
		const { sortCriteria } = this.props
		if (this.props.isLoadingContracts === true) {
			return <LoadingPage />
		} else if (this.props.contracts === null) {
			return (
				<div className='loader-container'>
					<Typography variant='subtitle1' gutterBottom>
						{' '}
						<Translate id='common.errorToGetInformation' />
					</Typography>
				</div>
			)
		} else {
			return (
				<DataTable
					data={this.props.contracts}
					configuration={TableConfiguration(canBeModuleDocumentsEnvSupplier(this.props.userRolesByCompany))}
					onRenderCellItem={this.onRenderCellItem}
					sortBy={sortCriteria.by}
					sortAscending={sortCriteria.ascending}
					onChangeSortCriteria={this.onChangeSortCriteria}
					onRowClick={this.onRowClick}
					isIndex
					totalRows={this.props.contractsCount}
					page={this.props.page}
					rowsPerPage={this.props.rowsPerPage}
					onChangePage={(newPage, newRowsPerPage) => {
						this.props.changePage(newPage, newRowsPerPage)
					}}
				/>
			)
		}
	}

	/**
	 * Function to add new documents
	 */
	onClickAddButton() {
		this.props.history.push(`/documents/create`)
	}

	/**
	 * Handle click of options menu component to set item Token in state nd open menu
	 *
	 * @param {*} token
	 * @memberof Index
	 */
	handleClickOptionsMenu(token) {
		this.setState({
			itemToken: token,
		})
	}

	/**
	 * Handle on close optons menu to set void item token in state
	 *
	 * @memberof Index
	 */
	handleCloseOptionsMenu() {
		this.setState(
			{
				itemToken: '',
				showMenu: false,
			},
			() => {
				this.setState({ showMenu: true })
			}
		)
	}

	/**
	 *Render action button in card download
	 *
	 * @memberof Index
	 */
	renderAction() {
		var options = []
		options.push({
			itemClick: () => this.onDownloadReport(),
			tooltipTranslation: <Translate id='common.downloadReport' />,
			menuItemIcon: <DownloadIcon color='secondary' />,
			isLoading: this.props.isDownloadingReport,
		})
		if (this.state.showMenu)
			return (
				<OptionsMenu
					itemToken={'item.token'}
					handleClickOptions={this.handleClickOptionsMenu}
					open={this.state.itemToken === 'item.token'}
					handleClickAway={this.handleCloseOptionsMenu}
					options={options}
				/>
			)
	}

	/**
	 *Download report of from contacts
	 *
	 * @memberof Index
	 */
	onDownloadReport() {
		this.props
			.downloadReportSupplierContractors(DOCUMENT_ENVIROMENTAL)
			.then(() => {
				showSuccessToaster('common.downloadCorrectly')
			})
			.catch(() => {
				showErrorToaster('common.errorToDownload')
			})
	}

	/**
	 * Create instance
	 */
	render() {
		const { classes } = this.props
		return (
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<DocumentsIcon />
						</Avatar>
					}
					action={
						<div className={classes.actionsToolbar}>
							<SearchInput onChangeSearchValue={this.onChangeSearchValue} />

							{canBeModuleDocumentsEnvSupplier(this.props.userRolesByCompany) && (
								<Fab
									size='small'
									color='primary'
									onClick={() => {
										this.onClickAddButton()
									}}
								>
									<AddtIcon />
								</Fab>
							)}

							{this.renderAction()}
						</div>
					}
					title={<Typography variant='button'>{<Translate id='constracts.documentsTitle' />}</Typography>}
					subheader={this.getCounterMessage()}
				/>

				<CardContent>{this.getCardContent()}</CardContent>

				<Toaster
					message={<Translate id={this.state.toasterMessage} />}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</Card>
		)
	}
}

function TableConfiguration(isDisabled) {
	let columns = [
		{
			header: <Translate id='officialNotices.status' />,
			dataSource: 'status',
		},
		{
			header: 'Folio',
			dataSource: 'folio',
		},
		{
			header: <Translate id='officialNotices.activationDate' />,
			dataSource: 'start_date',
		},
		{
			header: <Translate id='officialNotices.expirationDate' />,
			dataSource: 'end_date',
		},
		{
			header: <Translate id='common.supplier' />,
			dataSource: 'supplier_name',
		},
		{
			header: <Translate id='constracts.nameDocument' />,
			dataSource: 'name',
		},
	]

	return { columns }
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	let userRolesByCompany = state.profile.get('userRolesByCompany')
	return {
		isLoadingUser: state.oidc.isLoadingUser,
		isLoadingContracts: state.contracts.get('isLoadingContracts'),
		contracts: state.contracts.get('contracts') ? state.contracts.get('contracts').toJS() : null,
		isSavingContract: state.contracts.get('isSavingContract'),
		isDownloadingReport: state.contracts.get('isDownloadingReport'),
		sortCriteria: state.contracts.get('sortCriteria') ? state.contracts.get('sortCriteria').toJS() : null,
		searchQuery: state.contracts.get('searchQuery'),
		page: state.contracts.get('page'),
		rowsPerPage: state.contracts.get('rowsPerPage'),
		contractsCount: state.contracts.get('contractsCount'),
		userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
		translate: getTranslate(state.localize),
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadContracts: (query, orderBy, sortAscending, page, rowsPerPage, documentType) => {
			dispatch(loadContractsFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage, documentType))
		},
		changeSortCriteria: (sortBy, sortAscending) => {
			dispatch({
				type: CHANGE_CONTRACTS_SORT_CRITERIA,
				sortCriteria: {
					by: sortBy,
					ascending: sortAscending,
				},
			})
		},
		changeSearchQuery: (query) => {
			dispatch({
				type: CHANGE_CONTRACTS_SORT_QUERY,
				query: query,
			})
		},
		changePage: (page, rowsPerPage) => {
			dispatch({
				type: CHANGE_CONTRACTS_PAGINATION,
				page,
				rowsPerPage,
			})
		},
		getContractsCount: (documentType) => {
			return dispatch(getContractsCount(documentType))
		},
		createContractData: (contract) => {
			return dispatch(createContractData(contract))
		},
		downloadReportSupplierContractors: (documentType) => {
			return dispatch(downloadReportSupplierContractors(documentType))
		},
	}
}

const styles = (theme) => ({
	avatar: {
		backgroundColor: theme.palette.secondary.main,
	},
	actionsToolbar: {
		display: 'flex',
	},
	searchInput: {
		marginTop: '3px',
		marginRight: '15px',
	},
	showingUsersCounter: {
		color: theme.palette.secondary.main,
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(IndexDocuments)))
)
